module.exports = __webpack_public_path__ + "static/media/2017bj.46c38d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/images/2017bj.png
// module id = 258
// module chunks = 0